/**
 * Homepage adaptive mode — drives section visibility/order and messaging only.
 */

export const HOMEPAGE_MODE = /** @type {const} */ ({
  ACTIVE: 'active',
  DISCOVERY: 'discovery',
  ONBOARDING: 'onboarding',
});

/**
 * @param {object} opts
 * @param {boolean} opts.hasPersonalNextGame — anchored “Your next session” (live or personalised upcoming slot)
 * @param {number} opts.membershipCount — active clubs for this player
 * @returns {'active'|'discovery'|'onboarding'}
 */
export function deriveHomepageMode({ hasPersonalNextGame, membershipCount }) {
  if (hasPersonalNextGame) return HOMEPAGE_MODE.ACTIVE;
  if (membershipCount > 0) return HOMEPAGE_MODE.DISCOVERY;
  return HOMEPAGE_MODE.ONBOARDING;
}
